function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    quote\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.06,22.55c0-5.58,2.69-9.76,8-12.55l1.79,3.31c-3.53,2-5.32,4.35-5.32,8.08l.5,4.89-2.88-3.77a4.35,4.35,0,0,1,3-1.24,3.92,3.92,0,0,1,4.17,4,4.06,4.06,0,0,1-4.17,4.41C9.86,29.64,8.06,27.05,8.06,22.55Zm13.26,0c0-5.58,2.69-9.76,8-12.55l1.79,3.31c-3.53,2-5.32,4.35-5.32,8.08l.5,4.89L23.4,22.51a4.35,4.35,0,0,1,3-1.24,3.92,3.92,0,0,1,4.17,4,4.06,4.06,0,0,1-4.17,4.41C23.12,29.64,21.32,27.05,21.32,22.55Z",
  fill: "#231f20"
});

function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2);
}

export default SvgQuote;